/* Healthier Elements theme — interactions. No dependencies. */
(function () {
  'use strict';

  var theme = window.theme || {};
  var routes = theme.routes || { root: '/', cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  var strings = theme.strings || {};

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) {
    var fmt = theme.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var noDecimals = withCommas;
    var amount = withCommas + '.' + parts[1];
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.'))
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------------- Cart ---------------- */
  var drawer = null;
  var lastFocus = null;

  function getDrawer() { drawer = document.getElementById('CartDrawer'); return drawer; }

  function openDrawer() {
    if (!getDrawer()) { window.location.href = routes.cart_url; return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var close = qs('[data-cart-close]', drawer);
    if (close) { setTimeout(function () { close.focus(); }, 50); }
  }

  function closeDrawer() {
    if (!getDrawer()) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function setCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function refreshCart() {
    return fetch(routes.root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var wrap = document.getElementById('shopify-section-cart-drawer');
        if (!wrap || !data['cart-drawer']) return;
        var wasOpen = getDrawer() && drawer.classList.contains('is-open');
        var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = doc.getElementById('shopify-section-cart-drawer');
        wrap.innerHTML = fresh ? fresh.innerHTML : data['cart-drawer'];
        getDrawer();
        if (drawer) {
          setCount(parseInt(drawer.getAttribute('data-count') || '0', 10));
          if (wasOpen) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
        }
      });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (json) {
        if (!r.ok || json.status) { throw new Error(json.description || json.message || strings.cartError || 'Something went wrong. Please try again.'); }
        return json;
      });
    });
  }

  function addItems(items) {
    return postJSON(routes.cart_add_url + '.js', { items: items });
  }

  function changeLine(line, quantity) {
    return postJSON(routes.cart_change_url + '.js', { line: line, quantity: quantity });
  }

  theme.addItems = addItems;
  theme.refreshCart = refreshCart;
  theme.openCart = openDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && getDrawer()) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }

    var lineBtn = e.target.closest('[data-line-change]');
    if (lineBtn) {
      e.preventDefault();
      var line = parseInt(lineBtn.getAttribute('data-line'), 10);
      var qty = parseInt(lineBtn.getAttribute('data-qty'), 10);
      var container = lineBtn.closest('[data-cart-items]');
      if (container) container.classList.add('is-updating');
      changeLine(line, Math.max(0, qty))
        .then(function () {
          if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
          return refreshCart();
        })
        .catch(function (err) {
          if (container) container.classList.remove('is-updating');
          alert(err.message);
        });
      return;
    }

    var multi = e.target.closest('[data-add-items]');
    if (multi) {
      e.preventDefault();
      var items;
      try { items = JSON.parse(multi.getAttribute('data-add-items')); } catch (err) { items = []; }
      items = items.filter(function (i) { return i && i.id; });
      if (!items.length) return;
      multi.classList.add('is-loading');
      addItems(items)
        .then(refreshCart)
        .then(function () {
          multi.classList.remove('is-loading');
          multi.classList.add('is-added');
          var cta = qs('[data-cta]', multi);
          if (cta && multi.getAttribute('data-added-text')) cta.textContent = multi.getAttribute('data-added-text');
          openDrawer();
        })
        .catch(function (err) { multi.classList.remove('is-loading'); alert(err.message); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (getDrawer() && drawer.classList.contains('is-open')) closeDrawer();
      var nav = qs('[data-mobile-nav]');
      if (nav && !nav.hidden) toggleMenu(false);
    }
  });

  /* ---------------- Product form ---------------- */
  qsa('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!getDrawer()) return; // fall back to normal post
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = document.querySelector('[form="' + form.id + '"][name="quantity"]') || form.querySelector('[name="quantity"]');
      var errorEl = qs('[data-form-error]', form.parentNode) || qs('[data-form-error]');
      var buttons = qsa('[type="submit"][form="' + form.id + '"]').concat(qsa('[type="submit"]', form));
      buttons.forEach(function (b) { b.classList.add('is-loading'); });
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      addItems([{ id: parseInt(idInput.value, 10), quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1 }])
        .then(refreshCart)
        .then(function () { openDrawer(); })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } else { alert(err.message); }
        })
        .then(function () { buttons.forEach(function (b) { b.classList.remove('is-loading'); }); });
    });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    var input = wrap && qs('input', wrap);
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, v);
  });

  /* ---------------- Variant picker ---------------- */
  qsa('[data-product]').forEach(function (root) {
    var json = qs('script[data-variants]', root);
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var form = qs('form[data-product-form]', root);
    var idInput = form && qs('[name="id"]', form);
    var groups = qsa('[data-option-group]', root);

    function current() {
      var chosen = groups.map(function (g) { var c = qs('input:checked', g); return c ? c.value : null; });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < chosen.length; j++) { if (v.options[j] !== chosen[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function update() {
      var v = current();
      var buttons = qsa('[data-add-button]');
      if (!v) {
        buttons.forEach(function (b) { b.disabled = true; var t = qs('[data-add-text]', b) || b; t.textContent = strings.unavailable || 'Unavailable'; });
        return;
      }
      if (idInput) idInput.value = v.id;
      qsa('[data-price]').forEach(function (el) { el.textContent = money(v.price); });
      qsa('[data-compare]').forEach(function (el) {
        if (v.compare_at_price && v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price); el.hidden = false; } else { el.hidden = true; }
      });
      qsa('[data-variant-title]').forEach(function (el) { el.textContent = v.title; });
      qsa('[data-variant-detail]').forEach(function (el) { el.textContent = el.getAttribute('data-detail-' + v.id) || ''; });
      qsa('[data-stock]').forEach(function (el) {
        el.textContent = v.available ? (strings.inStock || 'In stock') : (strings.soldOut || 'Sold out');
        el.classList.toggle('stock--out', !v.available);
      });
      buttons.forEach(function (b) {
        b.disabled = !v.available;
        var t = qs('[data-add-text]', b);
        if (t) t.textContent = v.available ? (b.getAttribute('data-label') || strings.addToCart || 'Add to cart') + (b.hasAttribute('data-with-price') ? ' · ' + money(v.price) : '') : (strings.soldOut || 'Sold out');
      });
      if (v.featured_media_id) showMedia(root, v.featured_media_id);
      if (window.history && window.history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    groups.forEach(function (g) { g.addEventListener('change', update); });
  });

  /* ---------------- Media gallery ---------------- */
  function showMedia(root, mediaId) {
    var items = qsa('[data-media-item]', root);
    var found = false;
    items.forEach(function (el) {
      var on = el.getAttribute('data-media-id') === String(mediaId);
      if (on) found = true;
      el.classList.toggle('is-active', on);
    });
    if (!found && items[0]) items[0].classList.add('is-active');
    qsa('[data-media-thumb]', root).forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-media-id') === String(mediaId) ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-thumb]');
    if (!thumb) return;
    var root = thumb.closest('[data-product]') || document;
    showMedia(root, thumb.getAttribute('data-media-id'));
  });

  /* ---------------- Sticky buy bar ---------------- */
  var sticky = qs('[data-sticky-buy]');
  var anchor = qs('[data-buy-anchor]');
  if (sticky && anchor) {
    document.body.classList.add('has-sticky-buy');
    var stickyShown = null;
    var ticking = false;
    var checkSticky = function () {
      ticking = false;
      var past = anchor.getBoundingClientRect().bottom < 0;
      if (past === stickyShown) return;
      stickyShown = past;
      sticky.classList.toggle('is-visible', past);
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      qsa('a, button', sticky).forEach(function (el) { el.tabIndex = past ? 0 : -1; });
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(checkSticky); }
    }, { passive: true });
    window.addEventListener('resize', checkSticky);
    checkSticky();
  }

  /* ---------------- System finder ---------------- */
  qsa('[data-finder]').forEach(function (finder) {
    var state = { problem: null, size: 0 };
    var sizeStep = qs('[data-finder-size]', finder);

    function render() {
      qsa('[data-problem]', finder).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-problem') === state.problem ? 'true' : 'false'); });
      qsa('[data-size]', finder).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-size') === String(state.size) ? 'true' : 'false'); });
      var chosen = state.problem !== null ? qs('[data-problem="' + state.problem + '"]', finder) : null;
      var isContact = chosen && chosen.getAttribute('data-kind') === 'contact';
      if (sizeStep) sizeStep.hidden = !chosen || isContact;
      qsa('[data-result]', finder).forEach(function (r) {
        var key = r.getAttribute('data-result');
        r.hidden = !(chosen && (key === state.problem + '-' + state.size || (isContact && key === state.problem)));
      });
    }

    finder.addEventListener('click', function (e) {
      var p = e.target.closest('[data-problem]');
      var s = e.target.closest('[data-size]');
      if (p) { state.problem = p.getAttribute('data-problem'); render(); }
      if (s) { state.size = parseInt(s.getAttribute('data-size'), 10); render(); }
    });

    var first = qs('[data-problem]', finder);
    if (first && finder.hasAttribute('data-preselect')) state.problem = first.getAttribute('data-problem');
    render();
  });

  /* ---------------- Mobile menu ---------------- */
  function toggleMenu(open) {
    var nav = qs('[data-mobile-nav]');
    var btn = qs('[data-menu-toggle]');
    if (!nav) return;
    nav.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var c = qs('[data-menu-close]', nav); if (c) c.focus(); } else if (btn) { btn.focus(); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) { e.preventDefault(); toggleMenu(true); }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); toggleMenu(false); }
  });

  /* Close desktop dropdowns when clicking elsewhere */
  document.addEventListener('click', function (e) {
    qsa('.header__nav details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });

  /* Sort select on collection pages */
  qsa('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
})();
